import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73ca44ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-info-list" }
const _hoisted_2 = { class: "set-download-nums" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "more-info-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auto-download-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "设备开机自启下载任务"),
  /*#__PURE__*/_createElementVNode("p", null, "开启后盒子设备开机后，将自动开始下载进行中任务。暂停或失败状态的任务将不受影响。")
], -1))

import { ref, onMounted, watchEffect } from 'vue'
import Page from '@remote/components/layout/SubPage.vue'
import MoreInfoItem from '@remote/components/MoreInfoItem.vue'
import SettingItem from '@remote/components/SettingItem.vue'
import SpeedSetting from '@remote/components/SpeedSetting.vue'
import Switch from '@remote/components/switchbox/Switch.vue'
import { getTransportSettings, setTransportSettings, TTransportConfig } from '@remote/api/adapter/shell-mqtt'
import { useHeziSettingsStore } from '@remote/store/settings'
import { checkState } from '@remote/store/utils'
import { toast } from '@remote/utils/dialog'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let timer: NodeJS.Timeout | null
const transportConfig = ref<Pick<TTransportConfig, 'concurrent_downloads' | 'download_speed_limit'>>({ concurrent_downloads: 5, download_speed_limit: -1 })
const { state: heziSettingsState, toggleSetHeziService } = useHeziSettingsStore()
const isAutoDownload = ref(heziSettingsState.isAutoDownload)
const concurrentDownloads = ref(5)

watchEffect(() => {
  isAutoDownload.value = heziSettingsState.isAutoDownload
})

onMounted(() => {
  getTransportSettings()
    .then(res => {
      console.log(res)
      if (res.ret === 0 && res.result) {
        transportConfig.value = res.result
        concurrentDownloads.value = res.result.concurrent_downloads
      }
    })
})

const handleOnSetTransportSettings = (params: Partial<TTransportConfig>) => {
  if (checkState(true, true, false)) return
  const nextConfig = Object.assign({}, transportConfig.value, params) as TTransportConfig
  transportConfig.value = nextConfig
  concurrentDownloads.value = nextConfig.concurrent_downloads
  if (typeof timer === 'undefined') {
    setTransportSettings(nextConfig)
    timer = null
  } else {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      setTransportSettings(nextConfig)
    }, 1000)
  }
}

const handlePlusMinusConcurrentDownloads = (num: number) => {
  if (num < 1 || num > 20) return
  if (checkState(true, true, false)) return
  let number = num || transportConfig.value.concurrent_downloads
  number = Math.min(20, number)
  handleOnSetTransportSettings({ concurrent_downloads: number })
}

const handleOnSetConcurrentDownloads = () => {
  let number = concurrentDownloads.value
  if (isNaN(number)) number = transportConfig.value.concurrent_downloads as number
  if (number <= 0) number = 1
  number = Math.min(20, number)
  handleOnSetTransportSettings({ concurrent_downloads: number })
}

const handleOnInputConcurrentDownloads = (event: InputEvent) => {
  if (checkState(true, true, false)) return transportConfig.value = Object.assign({}, transportConfig.value)
  const number = +parseFloat((event?.target as HTMLInputElement).value.trim()).toFixed()
  // @ts-ignore
  concurrentDownloads.value = isNaN(number) ? '' : number
}

const handleOnToggleAutoDownload = () => {
  if (checkState(true, false, false)) return isAutoDownload.value = !!isAutoDownload.value
  isAutoDownload.value = !isAutoDownload.value
  const setHeziService = () => {
    toggleSetHeziService('isAutoDownload', isAutoDownload.value)
      .then(() => {
        // store.commit('toast', '设置成功')
      }).catch((err) => {
        toast({type: 'success', message: err || '设置失败'})
      })
  }
  if (typeof timer === 'undefined') {
    console.log('handleOnToggleAutoDownload', 1, timer)
    setHeziService()
    timer = null
  } else {
    console.log('handleOnToggleAutoDownload', 2, timer)
    timer && clearTimeout(timer)
    timer = setTimeout(setHeziService, 1500)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, { title: "传输设置" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingItem, {
          title: "下载速度设置",
          "list-title": "下载速度设置",
          "is-bottom": "",
          "click-id": "set_downloadspeed"
        }, {
          content: _withCtx(() => [
            _createVNode(SpeedSetting, {
              "speed-limit": transportConfig.value?.download_speed_limit,
              onSetSpeed: handleOnSetTransportSettings
            }, null, 8, ["speed-limit"])
          ]),
          _: 1
        }),
        _createVNode(MoreInfoItem, { title: "同时下载任务数" }, {
          arrow: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("i", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePlusMinusConcurrentDownloads(transportConfig.value.concurrent_downloads - 1))),
                disabled: transportConfig.value.concurrent_downloads <= 1
              }, null, 8, _hoisted_3),
              _createElementVNode("input", {
                value: concurrentDownloads.value,
                onInput: handleOnInputConcurrentDownloads,
                onBlur: handleOnSetConcurrentDownloads
              }, null, 40, _hoisted_4),
              _createElementVNode("i", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePlusMinusConcurrentDownloads(transportConfig.value.concurrent_downloads + 1))),
                disabled: transportConfig.value.concurrent_downloads >= 20
              }, null, 8, _hoisted_5)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(MoreInfoItem, null, {
          title: _withCtx(() => [
            _hoisted_7
          ]),
          arrow: _withCtx(() => [
            _createElementVNode("div", {
              class: "set-auto-download",
              onClick: handleOnToggleAutoDownload
            }, [
              _createVNode(Switch, { value: isAutoDownload.value }, null, 8, ["value"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})